import { render, staticRenderFns } from "./ClientClickEventsModal.vue?vue&type=template&id=3f817b79&scoped=true&"
import script from "./ClientClickEventsModal.vue?vue&type=script&lang=js&"
export * from "./ClientClickEventsModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientClickEventsModal.vue?vue&type=style&index=0&id=3f817b79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f817b79",
  null
  
)

export default component.exports